import { useState, useMemo } from "react";
import { Button, ModalDelete, Label } from "expano-components";
import useGet from "hooks/useGet";
import useDelete from "hooks/useDelete";
import { Main, PageLoader, Dashboard, Error } from "components";

import { ReactComponent as PlatformIcon } from "icons/platform.svg";

import AddShop from "./modals/AddShop";
import BasicData from "./components/BasicData";

const PlatformEdit = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const [show_delete_modal, setShowDeleteModal] = useState(false);
  const [show_add_shop_modal, setShowAddShopModal] = useState(false);
  const [channel_to_delete, setChannelToDelete] = useState({
    id: null,
    name: null,
  });

  const {
    is_loading,
    is_error,
    error,
    data: platform,
    refetch,
  } = useGet({
    query: ["platforms", id],
    path: `/platforms/${id}`,
    context: "ui_show",
  });

  const shop_ids = useMemo(() => {
    if (!platform?.channels.length) {
      return [];
    }
    return platform.channels.map(({ shop }) => shop?.id);
  }, [platform?.channels]);

  const { _delete: deletePlatform } = useDelete({
    path: `/platforms/${id}`,
    onSuccess: () => {
      setShowDeleteModal(false);
      history.push("/platforms");
    },
  });

  const { _delete: deleteChannel } = useDelete({
    path: `/channels/${channel_to_delete?.id}`,
    onSuccess: () => {
      setChannelToDelete(false);
      refetch();
    },
  });

  if (is_loading) {
    return <PageLoader />;
  }

  if (is_error) {
    return <Error message={error} />;
  }

  return (
    <Main
      page={{
        name: platform?.name,
        icon: <PlatformIcon />,
        breadcrumbs: [
          {
            name: "Platformy",
            path: "/platforms",
          },
          { name: platform?.name },
        ],
        buttons: (
          <Button
            type="delete"
            text="Usuń platformę"
            onClick={() => setShowDeleteModal(true)}
          />
        ),
      }}
    >
      {show_delete_modal && (
        <ModalDelete
          handleDelete={deletePlatform}
          handleClose={() => setShowDeleteModal(false)}
          name={`platformę ${platform?.name}?`}
        />
      )}
      {channel_to_delete?.id && (
        <ModalDelete
          handleDelete={deleteChannel}
          handleClose={() => setChannelToDelete(null)}
          name={`kanał ${channel_to_delete.identifier}?`}
        />
      )}
      {show_add_shop_modal && (
        <AddShop
          platform_id={platform?.id}
          shop_ids={shop_ids}
          refetch={refetch}
          handleClose={() => setShowAddShopModal(false)}
        />
      )}
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <BasicData
            platform_id={platform?.id}
            initialValues={{
              name: platform?.name,
              identifier: platform?.identifier,
              label_text: platform?.label_text,
              label_color: platform?.label_color,
              type: platform?.type,
              country_code: platform?.country_code,
              currency_code: platform?.currency_code,
              language: platform?.language,
              offer_title_max_length: platform?.offer_title_max_length ?? 100,
              source_platform_id:
                platform?.source_platform_id == null || platform?.source_platform_id === ""
                  ? null
                  : Number(platform.source_platform_id),
            }}
          />
        </div>
        <div className="column-half">
          <Dashboard
            header={{
              icon: "shop",
              title: "Sklepy",
            }}
            footer={
              <Button
                type="add"
                text="Dodaj sklep"
                onClick={() => setShowAddShopModal(true)}
              />
            }
          >
            {platform?.channels?.length > 0 && (
              <table className="table">
                <thead className="table__header table-head">
                  <tr>
                    <th>Nazwa</th>
                    <th>Działania</th>
                  </tr>
                </thead>
                <tbody className="table__body table-body">
                  {platform.channels.map(({ id, identifier, shop }) => (
                    <tr key={id}>
                      <td>
                        <Label
                          text={shop?.label_text}
                          type="fill"
                          color={shop?.label_color}
                        />
                        {shop?.name} ({identifier})
                      </td>
                      <td>
                        <Button
                          type="delete-bin"
                          onClick={() =>
                            setChannelToDelete({
                              id,
                              identifier,
                            })
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Dashboard>
        </div>
      </div>
    </Main>
  );
};

export default PlatformEdit;
